<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-de-dossier-signaletique-form' }" icon-right="add_circle">{{$t('processes.create_suivi_de_dossier_signaletique')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="processes"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: 'suivi-de-dossier-signaletique-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDeSuiviDeDossierSignaletiqueList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'signaletique')
  },

  meta () {
    return {
      title: 'Suivi de dossier signalétique'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      suiviDeDossierSignaletiqueProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    processes () {
      return this.suiviDeDossierSignaletiqueProcesses
    },
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },

    columns () {
      if (this.processes.length === 0) return []
      else {
        const fields = ['entities', 'wallets', 'origine_du_besoin', 'date_effet', 'date_de_pose', 'statut']
        const sortable = ['entities', 'wallets', 'origine_du_besoin']

        return fields.map((key, index) => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'entities') {
            label = this.$t(`processes.fields.entity.label`)
            formatFn = val => val.map(entity => entity.label).join(', ')
          } else if (key === 'wallets') {
            label = this.$t(`processes.fields.pdv.label`)
            formatFn = val => val.map(wallet => wallet.NOMPTF).join(', ')
          } else if (key === 'origine_du_besoin') {
            label = this.$t(`processes.fields.besoin.label`)
            formatFn = val => val ? this.$t(`processes.origineBesoin.${val}`) : ''
          } else if (key === 'date_effet' || key === 'date_de_pose') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'statut') {
            formatFn = val => val ? this.$t(`processes.status.${val}`) : ''
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    // if (this.filters) {
    this.onRequest({ pagination: this.pagination })
    // }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_de_dossier_signaletique'), to: { name: 'suivi-de-dossier-signaletique-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_de_dossier_signaletique'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-de-dossier-signaletique-en-cours', label: 'En cours', to: { name: 'suivi-de-dossier-signaletique-en-cours' } },
      { name: 'suivi-de-dossier-signaletique-archivés', label: 'Archivés', to: { name: 'suivi-de-dossier-signaletique-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'signaletique' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList () {
      this.$axios.get('/api/processAgences/signaletique/export', {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, 'signaletique.csv')
      }).catch(this.$notifyError)
    }
  }
}
</script>
